import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const ResRedGoldCase = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL(`https://blog.loadsmart.com/case-study-red-gold` + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = `https://blog.loadsmart.com/case-study-red-gold`;
    }
  }, [pathURL]);
  return <div />;
};

export default ResRedGoldCase;
